import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {NotFoundComponent} from './shared/components/not-found/not-found.component';
import {AuthCallbackComponent} from './shared/components/auth-callback/auth-callback.component';
import {AuthErrorComponent} from './shared/components/auth-error/auth-error.component';
import {authGuard} from '@app/core';
import {PdfComponent} from './features/pdf/pages/pdf/pdf.component';

const routes: Routes = [
  // Ruta de callback EXCLUIDA de la protección
  { path: 'auth/callback', component: AuthCallbackComponent },
  // Destino del authGuard cuando no se puede cargar el usuario: fuera de la protección para no entrar en bucle
  { path: 'auth/error', component: AuthErrorComponent },
  {path: 'estado-pago/:id/:clientId/:currencyId/:companyName', component: PdfComponent},
  {path: 'estado-pago/:id/:clientId/:currencyId', component: PdfComponent},
  {path: 'orden-compra/:id/:clientId/:currencyId/:companyName', component: PdfComponent},
  {path: 'orden-compra/:id/:clientId/:currencyId', component: PdfComponent},
  {
    path: '',
    canActivate: [authGuard], // Protege TODAS las rutas hijas
    children: [
      { path: '', redirectTo: '/projects', pathMatch: 'full' },
      { path: 'home', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) },
      { path: 'inbox', loadChildren: () => import('./features/inbox/inbox.module').then(m => m.InboxModule) },
      { path: 'projects', loadChildren: () => import('./features/project/project.module').then(m => m.ProjectModule) },
      { path: 'administration', loadChildren: () => import('./features/administration/administration.module').then(m => m.AdministrationModule) },
      { path: 'documents', loadChildren: () => import('./features/documents/documents.module').then(m => m.DocumentsModule) },
      { path: 'catalog', loadChildren: () => import('./features/catalog/catalog.module').then(m => m.CatalogModule) },
      { path: 'configuration', loadChildren: () => import('./features/configuration/configuration.module').then(m => m.ConfigurationModule) },
      { path: 'user', loadChildren: () => import('./features/user/user.module').then(m => m.UserModule) },
      { path: 'library', loadChildren: () => import('./features/library/library.module').then(m => m.LibraryModule) },
      { path: 'maestro', loadChildren: () => import('./features/maestros/maestros.module').then(m => m.MaestrosModule) },
      { path: 'search', loadChildren: () => import('./features/search/search.module').then(m => m.SearchModule) },
      { path: '404', component: NotFoundComponent },
      { path: '**', redirectTo: '/projects' }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
